export const DDC_MAP_FULLSCREEN = 'ddc.map.fullscreen';

function fullscreen(map) {
	return {
		eventType: DDC_MAP_FULLSCREEN,
		eventData: {
			// the map's container element, so pushEvent enrichment can
			// resolve the widget (widgetName/widgetHeading) it lives in
			element: map?.getDiv?.()
		}
	};
}

export default fullscreen;
